import { tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { UserAttributeKind } from '@hotjar/webapp/domains/user-attributes/model';
import type { TargetingRule } from '@hotjar/feedback/domain/common/TargetingRule/TargetingRule';
import { UserAttributeWrapper } from '@hotjar/global-filters';
import type { RadioDateFilterOperation } from '@hotjar/global-filters';

import {
  DATE_COMPARE_OPERATIONS,
  mapUIOperationToDtoValue,
  mapUserAttributeDtoToUIValue,
} from '@hotjar/feedback/domain/common/UserAttributes/UserAttributesOperationsMapping';

const Container = styled.div`
  display: inline-block;

  div[role='button'] {
    background: ${tokens.color.neutral_200};
  }
`;

export interface UserAttributesTargetingRuleProps {
  onRemoveRule: (rule: TargetingRule) => void;
  onChangeRule: (rule: TargetingRule) => void;
  rule: TargetingRule;
}

export function UserAttributesTargetingRule({
  rule,
  onRemoveRule,
  onChangeRule,
}: UserAttributesTargetingRuleProps): JSX.Element {
  return (
    <Container>
      <UserAttributeWrapper
        currentValue={mapUserAttributeDtoToUIValue(rule)}
        onApply={(newValue) => {
          if (newValue === undefined) {
            return;
          }
          const dtoOperation = mapUIOperationToDtoValue(newValue);
          // eslint-disable-next-line camelcase
          rule.match_operation = dtoOperation.operation;
          rule.negate = dtoOperation.negate;
          if (newValue.value && 'value' in newValue.value) {
            if (
              newValue.kind === UserAttributeKind.Date &&
              DATE_COMPARE_OPERATIONS.includes(newValue.value.operation as RadioDateFilterOperation)
            ) {
              rule.pattern = (newValue.value.value as Date).getTime() / 1000;
            } else {
              rule.pattern = newValue.value.value as string;
            }
          } else {
            rule.pattern = true;
          }
          onChangeRule(rule);
        }}
        onRemove={() => onRemoveRule(rule)}
        onDropdownHidden={() => {
          if (!rule.match_operation) {
            onRemoveRule(rule);
          }
        }}
        showDropdownOnMount={!rule.match_operation}
      />
    </Container>
  );
}
